export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;

export const PAYMENT_URL = import.meta.env.VITE_PAYMENT_URL as string;

export const TG_BOT_URL = import.meta.env.VITE_TG_BOT_URL as string;

export const TONCONNECT_MANIFEST_URL = import.meta.env.VITE_TONCONNECT_MANIFEST_URL as string;
